import { useNavigate } from 'react-router-dom';
import { useAtom, atom } from 'jotai'
import { getUserInfo, addUserInfo } from '../../api/api';
import { userInfoAtom } from '../../atom';
import { Amplify, Auth } from 'aws-amplify';
import awsExportsDWP from '../../aws-exports_DWP';

Amplify.configure(awsExportsDWP)
const firstLoginAtom = atom(true);


function MainComponent({ handleLoading }) {

    document.title = "NEC DWP| ファーストコンタクトセンター";
    const [, setUserInfo] = useAtom(userInfoAtom);
    const [isFirstLogin, setIsFirstLogin] = useAtom(firstLoginAtom);

    const navigate = useNavigate();

    const login = async () => {
        const nameCheck = ["", undefined, null, false];
        handleLoading(true);
        localStorage.removeItem("agreement");
        localStorage.removeItem("productionLists");
        try {
            const currentUserInfo = await Auth.currentUserInfo();
            var userId = "";
            var sfUserId = "";
            if (!nameCheck.includes(currentUserInfo)) {
                sfUserId = currentUserInfo.attributes.email.toLowerCase();
            } else {
                throw new Error("Email address Error");
            }
            // データ登録API
            const result = await addUserInfo(currentUserInfo.attributes.email.toLowerCase());
            if (result) {
                if (result.userId) {
                    userId = result.userId;
                } else {
                    throw new Error("addUserInfo Error");
                }
            } else {
                throw new Error("addUserInfo Error");
            }
            // データ取得API
            if (nameCheck.includes(userId)) {
                handleLoading(false);
                navigate("/fcc_login");
                return;
            } else {
                localStorage.setItem('userId', userId);
                localStorage.setItem('sfUserId', sfUserId);
            }

            const userInfo = await getUserInfo();
            if (!userInfo) {
                handleLoading(false);
                navigate("/fcc_login");
                return;
            }
            if (!nameCheck.includes(userInfo.email)) {
                localStorage.setItem('email', userInfo.email);
            } else {
                localStorage.setItem('email', currentUserInfo.attributes.email.toLowerCase());
            }
            localStorage.setItem("agreement", userInfo.agreeFlg)
            if (userInfo.agreeFlg !== 1) {
                handleLoading(false);
                navigate("/personal_information", { state: { page: true } });
                return;
            }
            // DWPユーザーはユーザ情報を編集できない
            // if (nameCheck.includes(userInfo.sei)
            //     || nameCheck.includes(userInfo.mei)
            //     || nameCheck.includes(userInfo.seiYomi)
            //     || nameCheck.includes(userInfo.meiYomi)) {
            //     // 漢字名入力画面に遷移する
            //     handleLoading(false);
            //     navigate("/input_kanji_name", { state: { page: true } });
            //     return;
            // }
            const userName = `${userInfo.sei} ${userInfo.mei}`;
            const user = {
                userId: userId,
                userName: userName,
            };
            setUserInfo(user);
            handleLoading(false);
            navigate("/inquiry_status", { state: { pageSubmit: false } });
        } catch (e) {
            handleLoading(false);
            navigate("/fcc_login");
            return;
        }
    }

    try {
        if (isFirstLogin === true) {
            login();
        } else {
            setIsFirstLogin(false);
        }
        setIsFirstLogin(false);
    } catch (err) {
        setIsFirstLogin(false);
        return false;
    }

    return (
        <div>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">NEC DWP</h1>
                            <span className="sub of-top">ログイン</span>
                        </div>
                    </div>
                    <div className="str-outer">
                        <div className="str-inner">
                            <div className="mod-tbl-form mb-30">
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}


export default MainComponent;